<template>
  <div>
    <div :id="editorId" class="editor_html"></div>
  </div>
</template>
<script>
import CommonFactory from '@/mixins/common.factory';
  export default {
    name: 'html-editor-ck',
    mixins:[CommonFactory],
    props: {
      value: {
        type: String,
        default: ''
      },
      name: String,
      referenceName: String,
      placeholder:String
    },
    data () {
      return {
        content: null,
        lastHtmlValue: '',
        editorId: null,
        toolbarId: null,
        editorObj:null,
      }
    },
    methods: {
      initialize () {
        const _self=this;

        _self.fn().createHtmlEditor(_self.editorId,_self.editorId,_self.value,function(editorObj,error){
          _self.editorObj=editorObj?editorObj:null;

          editorObj.model.document.on( 'change:data', () => {
            //_self.content = _self.editorObj.getData();
            _self.content=_self.fn().getHtmlEditorContent(_self.editorObj);
            _self.$emit('input', {referenceName:_self.referenceName,htmlContent:_self.content});
          });
        });
      },
      randomString() {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

        for (let i = 0; i < 5; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      }
    },
    async mounted () {
      this.editorId = this.randomString();
      this.toolbarId = this.randomString();
      this.$nextTick(() => {
        this.initialize()
      });
    },
    watch: {
      value (newVal) {
        if (newVal !== this.content) {
          //this.pasteHTML(newVal);
        }
      }
    }
  }
</script>
